module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.3f482321.ttf";